<template>
  <v-card flat>
    <v-expansion-panels v-model="panel1" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>{{ labels.cedantInfoTitle }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.cedantName }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <strong v-if="polMaster.cedAnt">{{ polMaster.cedAnt }} - {{ policyInfo.cedAntName }}</strong>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.cedAcctNoSfx }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.cedAcctNoSfx">{{ polMaster.cedAcctNoSfx }} - {{ policyInfo.acctNoSfxDesc }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.recip }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.recip">{{ polMaster.recip }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.cedPolNo">{{ polMaster.cedPolNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.cedCesNo }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.cedCesNo">{{ polMaster.cedCesNo }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.cedSI }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayNumber(polMaster.cedSI, 2) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.ourSharePct }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayNumber(polMaster.ourSharePct, 6) }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-spacer class="mt-2"></v-spacer>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>{{ labels.ccaDateTitle }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.ccaDate }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.ccaDate">{{ formatDate(polMaster.ccaDate) }}</span>
                  <span v-else> - </span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.ccdDate }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.ccdDate">{{ formatDate(polMaster.ccdDate) }}</span>
                  <span v-else> - </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div>{{ labels.coInsInfoTitle }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.appCoIns }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span v-if="polMaster.appCoIns === true">{{ formatBoolean(polMaster.appCoIns) }}</span>
                  <span v-else>{{ formatBoolean(polMaster.appCoIns) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.billCoIns }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ polMaster.billCoIns }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">{{ labels.coInsPct }}</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayNumber(polMaster.coInsPct, 6) }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'

export default {
  computed: {
    policyInfo() {
      return this.$store.state.underwriting.policy.policyInfo
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    }
  },
  data() {
    return {
      labels: {
        cedantInfoTitle: 'Reinsurance – Cedant’s Information',
        ccaDateTitle: 'Contract Certainty Dates',
        coInsInfoTitle: 'Coinsurance Information',
        cedantName: 'Cedant Name',
        cedAcctNoSfx: 'Suffix',
        recip: 'Reciprocal Business',
        cedPolNo: 'Cedant Policy No.',
        cedCesNo: 'Cession No.',
        cedSI: 'Cedant SI',
        ourSharePct: 'Our Share %',
        ccaDate: 'Acceptance Date',
        ccdDate: 'Documentation Date',
        appCoIns: 'Apply Coinsurance',
        billCoIns: 'Bill Coinsurance',
        coInsPct: 'Coinsurance %'
      },
      panel1: [0]
    }
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>
